module.exports = __webpack_public_path__ + "static/img/it4d-e-samu2.f564fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/it4d-e-samu2.png
// module id = duyE
// module chunks = 4